var map = {
	"./ATB.svg": 86226,
	"./MKB.svg": 88131,
	"./OTP.svg": 66990,
	"./PSB.svg": 70422,
	"./VTB.svg": 16901,
	"./absolute.svg": 54500,
	"./alfa.svg": 57467,
	"./avangard.svg": 27213,
	"./bank-center-invest.svg": 45209,
	"./drive-click.svg": 75906,
	"./expobank.svg": 72621,
	"./gazprom.svg": 47309,
	"./homebank.svg": 7536,
	"./ingosstrakh.svg": 96272,
	"./lokobank.svg": 86032,
	"./mail.svg": 26114,
	"./opening.svg": 4861,
	"./orange.svg": 56369,
	"./prim-soc-bank.svg": 5516,
	"./raiffeisen.svg": 49579,
	"./renessans.svg": 9579,
	"./rosselkhoz.svg": 14649,
	"./sberbank.svg": 61927,
	"./sovcombank.svg": 28962,
	"./t-bank.svg": 73956,
	"./ural.svg": 52737,
	"./zenit.svg": 34933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38543;